/**
 * TeacherWish — CM School Supply Wishlist App
 * assets/teacherwish-v9.js  (v12 — is.gd short links, direct redirect)
 */
(function () {
  'use strict';

  let twAllProducts    = [];
  let twVendorMap      = {};
  let twAvatarImg      = null;
  let twLoaded         = false;
  let twToastTimer     = null;
  let twIsShareView    = false;
  let twActiveCategory = null;
  let twCurrentList    = null;
  let twAllLists       = [];
  let twAutoSaveTimer  = null;
  let twMetafieldId    = null;
  let twCustomerId     = null;
  let twCloudEnabled   = false;

  const STORE_URL      = 'https://shopcmss.com';
  const NETLIFY_URL    = 'https://sparkly-teacher-cc9d05.netlify.app';
  const LS_KEY         = 'tw_data_v1';
  const LS_CATALOG_KEY = 'tw_catalog_v1';
  const PAGE_URL       = 'https://shopcmss.com/pages/teach-wishlist';

  const TW_CATEGORIES = [
    { label:'📚 School Supplies', handle:'school-supplies' },
    { label:'🎨 Decorations',     handle:'classroom-decorations' },
    { label:'📦 Storage',         handle:'classroom-storage-1' },
    { label:'🪑 Furniture',       handle:'classroom-furniture' },
  ];

  const EM = {
    pencil:'✏️',pen:'🖊️',marker:'🖊️',crayon:'🖍️',highlighter:'🖊️',
    notebook:'📓',paper:'📄',folder:'📁',binder:'📚',divider:'📑',
    glue:'🧴',scissor:'✂️',ruler:'📏',eraser:'⬜',staple:'📎',
    tissue:'🧻',kleenex:'🧻',sanitizer:'🧴',soap:'🧼',book:'📖',
    calculator:'🔢',paint:'🎨',brush:'🖌️',tape:'🪄',puzzle:'🧩',
    chair:'🪑',carpet:'🟧',block:'🧱',border:'🖼️',bulletin:'📌',
    science:'🔬',math:'🔢',music:'🎵',game:'🎮',default:'📦'
  };
  function twGetEmoji(name) {
    const l = (name||'').toLowerCase();
    for (const [k,v] of Object.entries(EM)) { if (l.includes(k)) return v; }
    return EM.default;
  }
  function twUuid() { return 'tw-'+Date.now().toString(36)+'-'+Math.random().toString(36).slice(2,7); }

  function twSaveAll() {
    try { localStorage.setItem(LS_KEY, JSON.stringify({ lists:twAllLists, activeId:twCurrentList?.id||null })); }
    catch(e) { console.warn('TW save error', e); }
    if (twCloudEnabled && twCustomerId) twSaveToCloud();
  }

  async function twSaveToCloud() {
    try {
      const res = await fetch(NETLIFY_URL+'/.netlify/functions/save-lists', {
        method:'POST', headers:{'Content-Type':'application/json'},
        body: JSON.stringify({ customer_id:twCustomerId, lists:twAllLists, metafield_id:twMetafieldId||null })
      });
      if (res.ok) { const d = await res.json(); if (d.metafieldId) twMetafieldId = d.metafieldId; }
    } catch(e) { console.warn('TW cloud save failed:', e.message); }
  }

  async function twLoadFromCloud(customerId) {
    try {
      const res = await fetch(`${NETLIFY_URL}/.netlify/functions/get-lists?customer_id=${customerId}`);
      if (!res.ok) return false;
      const d = await res.json();
      if (d.metafieldId) twMetafieldId = d.metafieldId;
      if (d.lists && d.lists.length > 0) {
        const cloudIds = new Set(d.lists.map(l => l.id));
        const localOnly = twAllLists.filter(l => !cloudIds.has(l.id));
        twAllLists = [...d.lists, ...localOnly];
        const saved = localStorage.getItem(LS_KEY);
        const activeId = saved ? JSON.parse(saved).activeId : null;
        twCurrentList = twAllLists.find(l => l.id === activeId) || twAllLists[0] || null;
        twSaveAll();
        return true;
      }
      return false;
    } catch(e) { return false; }
  }

  function twLoadFromStorage() {
    try {
      const raw = localStorage.getItem(LS_KEY);
      if (!raw) return;
      const d = JSON.parse(raw);
      twAllLists = d.lists || [];
      twCurrentList = twAllLists.find(l => l.id === d.activeId) || twAllLists[0] || null;
    } catch(e) { twAllLists = []; twCurrentList = null; }
  }

  function twQueueSave() {
    clearTimeout(twAutoSaveTimer);
    twAutoSaveTimer = setTimeout(() => { twAutoSave(); twSaveAll(); }, 800);
  }

  function twAutoSave() {
    if (!twCurrentList) return;
    twCurrentList.teacher.name   = document.getElementById('tw-teacher-name')?.value  || '';
    twCurrentList.teacher.grade  = document.getElementById('tw-teacher-grade')?.value || '';
    twCurrentList.teacher.msg    = document.getElementById('tw-teacher-msg')?.value   || '';
    twCurrentList.teacher.avatar = twAvatarImg || '';
    twCurrentList.updated        = new Date().toISOString();
  }

  function twItems()         { return twCurrentList?.items || []; }
  function twSetItems(items) { if (twCurrentList) twCurrentList.items = items; }

  function twNewList(name) {
    const list = { id:twUuid(), name:name||'My Wishlist', created:new Date().toISOString(),
      updated:new Date().toISOString(), teacher:{name:'',grade:'',msg:'',avatar:''}, items:[] };
    twAllLists.push(list);
    twActivateList(list);
    twSaveAll();
    return list;
  }

  function twActivateList(list) {
    twCurrentList = list;
    const nameEl=document.getElementById('tw-teacher-name'), gradeEl=document.getElementById('tw-teacher-grade'), msgEl=document.getElementById('tw-teacher-msg');
    if (nameEl)  nameEl.value  = list.teacher.name  || '';
    if (gradeEl) gradeEl.value = list.teacher.grade || '';
    if (msgEl)   msgEl.value   = list.teacher.msg   || '';
    if (list.teacher.avatar) {
      twAvatarImg = list.teacher.avatar;
      const avEl = document.getElementById('tw-av-display');
      if (avEl) avEl.innerHTML = `<img src="${twAvatarImg}" alt="Teacher photo">`;
    } else {
      twAvatarImg = null;
      const avEl = document.getElementById('tw-av-display');
      if (avEl) avEl.innerHTML = '🍎';
    }
    twRenderListManager();
    twUpdateStats();
  }

  window.twSwitchList = function(id) {
    twAutoSave(); twSaveAll();
    const list = twAllLists.find(l => l.id === id);
    if (list) { twActivateList(list); twSwitchTab('search'); twToast(`Switched to "${list.name}"`); }
  };
  window.twPromptNewList = function() {
    const name = prompt('Name your new wishlist:', 'Back to School '+new Date().getFullYear());
    if (!name) return;
    twNewList(name.trim()); twSwitchTab('search'); twToast(`"${name}" created! 🎉`);
  };
  window.twRenameList = function(id) {
    const list = twAllLists.find(l => l.id === id);
    if (!list) return;
    const name = prompt('Rename this list:', list.name);
    if (!name || name.trim() === list.name) return;
    list.name = name.trim(); twSaveAll(); twRenderListManager(); twToast('List renamed');
  };
  window.twDeleteList = function(id) {
    const list = twAllLists.find(l => l.id === id);
    if (!list) return;
    if (!confirm(`Delete "${list.name}"? This cannot be undone.`)) return;
    twAllLists = twAllLists.filter(l => l.id !== id);
    if (twCurrentList?.id === id) { twCurrentList = twAllLists[0] || null; if (twCurrentList) twActivateList(twCurrentList); }
    twSaveAll(); twRenderListManager(); twUpdateStats(); twToast('List deleted');
  };

  function twRenderListManager() {
    const el = document.getElementById('tw-list-manager');
    if (!el) return;
    if (!twAllLists.length) {
      el.innerHTML=`<div class="tw-lm-empty"><div style="font-size:28px;margin-bottom:8px">📋</div><div style="font-weight:700;color:var(--tw-ink);margin-bottom:4px">No wishlists yet</div><div style="font-size:12px;color:var(--tw-muted);margin-bottom:12px">Create your first wishlist to get started</div><button class="tw-btn-red" onclick="twPromptNewList()"><i class="ti ti-plus"></i> Create Wishlist</button></div>`;
      return;
    }
    el.innerHTML=`<div class="tw-lm-header"><div class="tw-lm-title">My Wishlists <span class="tw-badge">${twAllLists.length}</span></div><button class="tw-btn-red tw-btn-sm" onclick="twPromptNewList()"><i class="ti ti-plus"></i> New</button></div>
      ${twAllLists.map(list => {
        const isActive=twCurrentList?.id===list.id, itemCount=list.items.length, purchased=list.items.filter(i=>i.purchased).length;
        const dateStr=new Date(list.updated).toLocaleDateString('en-US',{month:'short',day:'numeric',year:'numeric'});
        return `<div class="tw-lm-item${isActive?' tw-lm-active':''}">
          <div class="tw-lm-item-body" onclick="twSwitchList('${list.id}')">
            <div class="tw-lm-item-name">${list.name}</div>
            <div class="tw-lm-item-meta">${itemCount} item${itemCount!==1?'s':''}${purchased>0?` · <span style="color:#2d6b40">✓ ${purchased} purchased</span>`:''} · Updated ${dateStr}</div>
          </div>
          <div class="tw-lm-item-actions">
            <button class="tw-lm-action-btn" onclick="event.stopPropagation();twRenameList('${list.id}')" title="Rename"><i class="ti ti-pencil"></i></button>
            <button class="tw-lm-action-btn tw-lm-action-del" onclick="event.stopPropagation();twDeleteList('${list.id}')" title="Delete"><i class="ti ti-trash"></i></button>
          </div></div>`;
      }).join('')}`;
  }

  // ── SHORT LINK via is.gd (direct redirect, no preview page) ───────────
  async function twCreateShareLink() {
    twAutoSave();
    const t = twCurrentList?.teacher || {};
    const data = {
      v:1, n:t.name||'', g:t.grade||'', m:t.msg||'', av:twAvatarImg||'',
      items: twItems().filter(i => !i.purchased).map(i => ({
        id:i.id, name:i.name, price:i.price, img:i.img||'',
        url:i.url||'', vendor:i.vendor||'', sku:i.sku||'',
        qty:i.qty||1, note:i.note||'', link:i.link||'', source:i.source||'cm'
      }))
    };
    const longUrl = `${PAGE_URL}?tw=${btoa(unescape(encodeURIComponent(JSON.stringify(data))))}`;
    const res = await fetch(`https://is.gd/create.php?format=simple&url=${encodeURIComponent(longUrl)}`);
    if (!res.ok) throw new Error('URL shortener unavailable');
    const shortUrl = (await res.text()).trim();
    if (!shortUrl.startsWith('https://is.gd/')) throw new Error('Invalid short URL');
    return shortUrl;
  }

  function twCheckLegacyShareLink() {
    const params = new URLSearchParams(window.location.search);
    const encoded = params.get('tw');
    if (!encoded) return false;
    try {
      const data = JSON.parse(decodeURIComponent(escape(atob(encoded))));
      if (!data?.items) return false;
      twIsShareView = true;
      twCurrentList = { id:'share-view', name:'Shared Wishlist',
        teacher:{name:data.n||'',grade:data.g||'',msg:data.m||'',avatar:data.av||''},
        items:data.items.map(i=>({...i,price:parseFloat(i.price||0),qty:i.qty||1,purchased:false})) };
      const nameEl=document.getElementById('tw-teacher-name'), gradeEl=document.getElementById('tw-teacher-grade'), msgEl=document.getElementById('tw-teacher-msg');
      if(nameEl) nameEl.value=data.n||''; if(gradeEl) gradeEl.value=data.g||''; if(msgEl) msgEl.value=data.m||'';
      if(data.av){twAvatarImg=data.av;const avEl=document.getElementById('tw-av-display');if(avEl)avEl.innerHTML=`<img src="${twAvatarImg}" alt="Teacher photo">`;}
      twShowParentViewOnly();
      return true;
    } catch(e) { return false; }
  }

  function twShowParentViewOnly() {
    const sidebar=document.getElementById('tw-sidebar'), main=document.getElementById('tw-main'), preview=document.getElementById('tw-preview');
    const hdrNav=document.querySelector('.tw-hnav'), shareBtn=document.querySelector('.tw-share-btn');
    if(sidebar)sidebar.style.display='none'; if(main)main.style.display='none'; if(preview)preview.style.display='block';
    if(hdrNav)hdrNav.style.display='none'; if(shareBtn)shareBtn.style.display='none';
    twRenderPreview();
  }

  async function twLoadCatalog() {
    if (twIsShareView) return;
    try {
      const cached = localStorage.getItem(LS_CATALOG_KEY);
      if (cached) {
        const obj = JSON.parse(cached);
        if (Date.now()-(obj.timestamp||0) < 86400000 && obj.products?.length > 100) {
          twFlattenProductsJson(obj.products);
          setTimeout(()=>twFetchAllProducts(true),5000);
          return;
        }
      }
    } catch(e) {}
    await twFetchAllProducts(false);
  }

  async function twFetchAllProducts(isBackground) {
    if (!isBackground) { twShowStatus('Loading CM School Supply catalog…'); twSetResultsHtml(`<div class="tw-info-box"><div class="tw-spinner"></div><span id="tw-load-msg">Loading catalog…</span></div>`); }
    try {
      let allProducts=[], page=1, keepGoing=true;
      while (keepGoing && page<=60) {
        const r=await fetch(`${STORE_URL}/collections/all/products.json?limit=250&page=${page}`);
        if(!r.ok) break;
        const d=await r.json(), batch=d.products||[];
        allProducts=allProducts.concat(batch); page++;
        if(!isBackground){const m=document.getElementById('tw-load-msg');if(m)m.textContent=`Loading… ${allProducts.length.toLocaleString()} products`;twShowStatus(`Loading catalog… ${allProducts.length.toLocaleString()} products`);}
        if(batch.length<250) keepGoing=false;
      }
      if(!allProducts.length) throw new Error('No products');
      try{localStorage.setItem(LS_CATALOG_KEY,JSON.stringify({products:allProducts,timestamp:Date.now()}));}catch(e){}
      twFlattenProductsJson(allProducts);
    } catch(e) { if(!isBackground){twHideStatus();twSetResultsHtml(`<div class="tw-error"><i class="ti ti-alert-circle"></i> Could not load catalog. Please refresh.</div>`);} }
  }

  async function twLoadCollection(handle,label) {
    twActiveCategory=handle; twUpdateCategoryBtns();
    twShowStatus(`Loading ${label}…`); twSetResultsHtml(`<div class="tw-info-box"><div class="tw-spinner"></div><span>Loading ${label}…</span></div>`);
    try {
      let allProducts=[], page=1, keepGoing=true;
      while(keepGoing&&page<=40){const r=await fetch(`${STORE_URL}/collections/${handle}/products.json?limit=250&page=${page}`);if(!r.ok)break;const d=await r.json(),batch=d.products||[];allProducts=allProducts.concat(batch);page++;if(batch.length<250)keepGoing=false;}
      twHideStatus(); twRenderProducts(twBuildProductList(allProducts),label,allProducts.length,false,handle);
    } catch(e) { twHideStatus(); twSetResultsHtml(`<div class="tw-error"><i class="ti ti-alert-circle"></i> Could not load collection.</div>`); }
  }

  function twFlattenProductsJson(products) {
    twAllProducts=twBuildProductList(products); twVendorMap=twBuildVendorMap(twAllProducts); twLoaded=true; twHideStatus();
    console.log(`TW: ready — ${twAllProducts.length.toLocaleString()} variants indexed`);
    twShowDefaultProducts();
  }

  function twBuildProductList(products) {
    const out=[];
    for(const p of products){
      const tags=Array.isArray(p.tags)?p.tags:(p.tags||'').split(',').map(t=>t.trim()).filter(Boolean);
      const img=p.images?.[0]?.src||null, variants=p.variants||[{}];
      for(const v of variants){
        const price=parseFloat(v.price||0); if(price<=0) continue;
        const variantLabel=(variants.length>1&&v.title&&v.title!=='Default Title')?` — ${v.title}`:'', skuRaw=v.sku||'';
        out.push({id:`cm-${p.id}${variants.length>1?'-'+v.id:''}`,name:p.title+variantLabel,baseTitle:p.title,
          vendor:p.vendor||'',vendorLower:(p.vendor||'').toLowerCase(),type:p.product_type||'',typeLower:(p.product_type||'').toLowerCase(),
          price,comparePrice:parseFloat(v.compare_at_price||0),sku:skuRaw.toLowerCase(),skuDisplay:skuRaw,barcode:(v.barcode||'').toLowerCase(),
          img,handle:p.handle,url:`${STORE_URL}/products/${p.handle}`,source:'cm',tags,tagsLower:tags.map(t=>t.toLowerCase()),
          _search:[p.title,p.vendor,p.product_type,skuRaw,v.barcode||'',v.title!=='Default Title'?v.title:'',...tags].join(' ').toLowerCase()});
      }
    }
    return out;
  }

  const KNOWN_ALIASES={'tcr':'teacher created resources','cd':'carson dellosa','cde':'carson dellosa education','em':'evan moor','ep':'edupress','sp':'scholastic','cr':'crayola','el':'elmer','av':'avery','md':'melissa & doug','ctp':'creative teaching press','lr':'learning resources','pcon':'pacon','hm':'houghton mifflin'};
  function twBuildVendorMap(products) {
    const map={...KNOWN_ALIASES}, vendors=[...new Set(products.map(p=>p.vendor).filter(Boolean))];
    for(const vendor of vendors){const words=vendor.toLowerCase().split(/\s+/).filter(w=>w.length>1),abbrev=words.map(w=>w[0]).join('');if(abbrev.length>=2&&abbrev.length<=5&&!map[abbrev])map[abbrev]=vendor.toLowerCase();}
    return map;
  }

  function twRenderCategoryBtns() {
    const wrap=document.getElementById('tw-category-btns'); if(!wrap) return;
    wrap.innerHTML=TW_CATEGORIES.map(cat=>`<button class="tw-cat-btn${twActiveCategory===cat.handle?' tw-cat-active':''}" onclick="twLoadCategory('${cat.handle}','${cat.label}')">${cat.label}</button>`).join('');
  }
  function twUpdateCategoryBtns() {
    document.querySelectorAll('.tw-cat-btn').forEach(btn=>btn.classList.toggle('tw-cat-active',btn.textContent.trim()===(TW_CATEGORIES.find(c=>c.handle===twActiveCategory)?.label||'')));
  }
  window.twLoadCategory=function(handle,label){const sq=document.getElementById('tw-search-q');if(sq)sq.value='';twLoadCollection(handle,label);};

  function twShowDefaultProducts() {
    twActiveCategory=null; twUpdateCategoryBtns();
    twRenderProducts(twAllProducts.slice(0,24),`CM School Supply — ${twAllProducts.length.toLocaleString()} Products`,twAllProducts.length,false,null);
  }

  window.twSearch=function(){
    const raw=(document.getElementById('tw-search-q').value||'').trim();
    if(!raw){twShowDefaultProducts();return;} if(!twLoaded){twToast('Still loading catalog — please wait');return;}
    twActiveCategory=null; twUpdateCategoryBtns();
    const q=raw.toLowerCase(), vendorExp=twVendorMap[q]||null, words=q.split(/\s+/).filter(w=>w.length>1), isPhrase=words.length>1;
    const scored=twAllProducts.map(p=>{
      let s=0;
      if(vendorExp){if(p.vendorLower===vendorExp)s+=100;else if(p.vendorLower.includes(vendorExp))s+=80;}
      if(p.sku===q)s+=150;else if(p.sku.startsWith(q))s+=80;else if(p.sku.includes(q))s+=50;
      if(p.barcode===q)s+=150;else if(p.barcode.includes(q))s+=40;
      if(p.typeLower===q)s+=120;else if(p.typeLower.includes(q))s+=60;
      const tl=p.baseTitle.toLowerCase();if(tl===q)s+=90;else if(tl.startsWith(q))s+=55;else if(tl.includes(q))s+=30;
      if(p.vendorLower===q)s+=70;else if(p.vendorLower.includes(q))s+=20;
      if(p.tagsLower.some(t=>t===q))s+=25;else if(p.tagsLower.some(t=>t.includes(q)))s+=12;
      if(s===0){if(isPhrase){const matched=words.filter(w=>p._search.includes(w));if(matched.length===words.length)s+=matched.length*10+20;else if(matched.length>0)s+=matched.length*5;}else{if(p._search.includes(q))s+=8;}}
      return{p,s};
    }).filter(x=>x.s>0).sort((a,b)=>b.s-a.s).map(x=>x.p);
    if(!scored.length){twSetResultsHtml(`<div class="tw-empty"><div class="tw-empty-icon">🔍</div><div class="tw-empty-title">No results for "${raw}"</div><div class="tw-empty-sub">Try a different keyword or SKU, or <a href="${STORE_URL}/search?q=${encodeURIComponent(raw)}&type=product" target="_blank" style="color:var(--tw-navy);font-weight:700;text-decoration:none">search on shopcmss.com ↗</a></div></div>`);return;}
    twRenderProducts(scored,`Results for "${raw}"`,scored.length,true,null);
  };

  function twProductCardHtml(p,il){
    const safe=encodeURIComponent(JSON.stringify({id:p.id,name:p.name,price:p.price,img:p.img,url:p.url,vendor:p.vendor,sku:p.skuDisplay||p.sku,source:'cm'}));
    const safeId=p.id.replace(/[^a-z0-9]/gi,'-'), onSale=p.comparePrice>p.price&&p.comparePrice>0;
    const imgHtml=p.img?`<img src="${p.img}" alt="${p.name.replace(/"/g,'&quot;')}" loading="lazy" onerror="this.style.display='none'">`:`<span style="font-size:34px">${twGetEmoji(p.name)}</span>`;
    return `<div class="tw-product-card${il?' tw-in-list':''}" onclick="twToggleProduct(decodeURIComponent('${safe}'))" id="tw-pc-${safeId}"><div class="tw-product-img">${imgHtml}</div><div class="tw-product-info"><div class="tw-product-name">${p.name}</div><div class="tw-product-price">$${p.price.toFixed(2)}${onSale?`<span style="text-decoration:line-through;color:var(--tw-muted);font-size:10px;margin-left:4px">$${p.comparePrice.toFixed(2)}</span>`:''}</div><div class="tw-product-vendor">${p.vendor}${p.skuDisplay?' · '+p.skuDisplay:''}</div></div><div class="tw-product-check"><i class="ti ti-check"></i></div></div>`;
  }

  function twRenderProducts(products,title,total,isSearch,collHandle){
    const inList=new Set(twItems().map(w=>w.id));
    const viewAllUrl=collHandle?`${STORE_URL}/collections/${collHandle}`:`${STORE_URL}/search?q=${encodeURIComponent(document.getElementById('tw-search-q')?.value||'')}&type=product`;
    twSetResultsHtml(`<div class="tw-section-header"><div class="tw-section-title">${title}<span class="tw-badge">${total.toLocaleString()} product${total!==1?'s':''}</span></div><a href="${viewAllUrl}" target="_blank" style="font-size:11px;color:var(--tw-navy);font-weight:700;text-decoration:none;white-space:nowrap">View all on site ↗</a></div><div class="tw-product-grid">${products.slice(0,30).map(p=>twProductCardHtml(p,inList.has(p.id))).join('')}</div>${total>30?`<div style="text-align:center;padding:10px;font-size:12px;color:var(--tw-muted)">Showing top 30 of ${total.toLocaleString()} — refine your search to see more</div>`:''}`);
  }

  function twSetResultsHtml(html){const el=document.getElementById('tw-results');if(el)el.innerHTML=html;}

  window.twToggleProduct=function(safe){
    if(!twCurrentList){twToast('Please create or select a wishlist first');return;}
    const p=JSON.parse(safe), items=twItems(), idx=items.findIndex(w=>w.id===p.id);
    if(idx>-1){items.splice(idx,1);twToast('Removed from wishlist');}else{items.push({...p,qty:1,purchased:false});twToast('Added to wishlist! 🎉');}
    twSetItems(items);
    const card=document.getElementById('tw-pc-'+p.id.replace(/[^a-z0-9]/gi,'-'));
    if(card) card.classList.toggle('tw-in-list',items.some(w=>w.id===p.id));
    twUpdateStats(); twQueueSave();
  };

  window.twAddCustom=function(){
    if(!twCurrentList){twToast('Please create or select a wishlist first');return;}
    const nameEl=document.getElementById('tw-c-name'), errEl=document.getElementById('tw-custom-error'), name=nameEl.value.trim();
    if(!name){document.getElementById('tw-custom-error-text').textContent='Please enter an item name.';errEl.style.display='flex';nameEl.focus();nameEl.style.borderColor='var(--tw-red)';setTimeout(()=>{nameEl.style.borderColor='';},2000);return;}
    errEl.style.display='none';
    const price=parseFloat(document.getElementById('tw-c-price').value.replace(/[^0-9.]/g,''))||0;
    const qty=Math.max(1,parseInt(document.getElementById('tw-c-qty').value)||1);
    const note=document.getElementById('tw-c-note').value.trim(), link=document.getElementById('tw-c-link').value.trim(), items=twItems();
    items.push({id:'custom-'+Date.now(),name,price,qty,note,link,source:'custom',img:null,vendor:'Custom',purchased:false});
    twSetItems(items);
    ['tw-c-name','tw-c-price','tw-c-note','tw-c-link'].forEach(id=>{document.getElementById(id).value='';});
    document.getElementById('tw-c-qty').value='1';
    twToast(`"${name}" added! 🎉`); twUpdateStats(); twQueueSave(); twSwitchTab('list');
  };

  function twRenderList(){
    const c=document.getElementById('tw-wishlist-items'), tb=document.getElementById('tw-total-bar'), items=twItems();
    if(!items.length){c.innerHTML=`<div class="tw-empty"><div class="tw-empty-icon">🛒</div><div class="tw-empty-title">This wishlist is empty</div><div class="tw-empty-sub">Browse CM products or add custom items</div></div>`;tb.style.display='none';return;}
    tb.style.display='block';
    const purchased=items.filter(i=>i.purchased).length, remaining=items.length-purchased;
    c.innerHTML=`${purchased>0?`<div class="tw-list-progress"><div class="tw-progress-bar"><div class="tw-progress-fill" style="width:${Math.round(purchased/items.length*100)}%"></div></div><div class="tw-progress-label">${purchased} of ${items.length} items purchased</div></div>`:''}
      ${items.map((item,i)=>`<div class="tw-wishlist-item${item.purchased?' tw-item-purchased':''}">
        <div class="tw-item-thumb">${item.img?`<img src="${item.img}" alt="" onerror="this.parentNode.innerHTML='${twGetEmoji(item.name)}'">`:twGetEmoji(item.name)}</div>
        <div class="tw-item-details"><div class="tw-item-name${item.purchased?' tw-purchased-text':''}">${item.name}</div><div class="tw-item-meta"><span class="tw-item-source ${item.source==='cm'?'tw-source-cm':'tw-source-custom'}">${item.source==='cm'?'CM Supply':'Custom'}</span>${item.vendor&&item.source==='cm'?`<span>${item.vendor}</span>`:''}${item.sku?`<span>SKU: ${item.sku}</span>`:''}${item.note?`<span>${item.note}</span>`:''}</div></div>
        ${item.price>0?`<div class="tw-item-price${item.purchased?' tw-purchased-text':''}">$${parseFloat(item.price).toFixed(2)}</div>`:`<div class="tw-item-price" style="color:var(--tw-muted);font-size:11px">—</div>`}
        <div class="tw-item-qty"><button class="tw-qty-btn" onclick="twChangeQty(${i},-1)">−</button><span class="tw-qty-num">${item.qty||1}</span><button class="tw-qty-btn" onclick="twChangeQty(${i},1)">+</button></div>
        <button class="tw-purchased-btn${item.purchased?' tw-purchased-on':''}" onclick="twTogglePurchased(${i})" title="${item.purchased?'Mark as needed':'Mark as purchased'}"><i class="ti ti-${item.purchased?'refresh':'check'}"></i></button>
        <button class="tw-remove-btn" onclick="twRemoveItem(${i})" aria-label="Remove"><i class="ti ti-trash"></i></button>
      </div>`).join('')}`;
    const total=items.filter(i=>!i.purchased).reduce((s,i)=>s+(parseFloat(i.price||0)*(i.qty||1)),0);
    document.getElementById('tw-grand-total').textContent='$'+total.toFixed(2);
    const lbl=document.getElementById('tw-total-label');if(lbl)lbl.textContent=remaining<items.length?`Remaining (${remaining} items)`:'Estimated Total';
  }

  window.twTogglePurchased=function(i){const items=twItems();items[i].purchased=!items[i].purchased;twSetItems(items);twRenderList();twUpdateStats();twQueueSave();twToast(items[i].purchased?'Marked as purchased ✓':'Marked as still needed');};
  window.twChangeQty=function(i,d){const items=twItems();items[i].qty=Math.max(1,(items[i].qty||1)+d);twSetItems(items);twRenderList();twUpdateStats();twQueueSave();};
  window.twRemoveItem=function(i){const n=twItems()[i].name;const items=twItems();items.splice(i,1);twSetItems(items);twRenderList();twUpdateStats();twQueueSave();twToast(`"${n}" removed`);};

  function twUpdateStats(){
    const items=twItems(), count=items.length, purchased=items.filter(i=>i.purchased).length;
    const total=items.filter(i=>!i.purchased).reduce((s,i)=>s+(parseFloat(i.price||0)*(i.qty||1)),0);
    const listName=twCurrentList?.name||'No list selected';
    [['tw-stat-items',count],['tw-stat-total',total>0?'$'+Math.round(total):'$0'],['tw-list-badge',count],['tw-stat-list-name',listName]]
      .forEach(([id,val])=>{const el=document.getElementById(id);if(el)el.textContent=val;});
    const pEl=document.getElementById('tw-stat-purchased');if(pEl)pEl.textContent=purchased>0?`${purchased} purchased`:'';
  }

  function twRenderPreview(){
    const t=twCurrentList?.teacher||{}, name=t.name||'Your Teacher';
    document.getElementById('tw-prev-name').textContent=name;
    document.getElementById('tw-prev-grade').textContent=t.grade||'';
    document.getElementById('tw-prev-msg').textContent=t.msg||'';
    const items=twItems().filter(i=>!i.purchased);
    document.getElementById('tw-prev-badge').textContent=items.length+' item'+(items.length!==1?'s':'');
    if(twAvatarImg) document.getElementById('tw-prev-avatar').innerHTML=`<img src="${twAvatarImg}" alt="${name}">`;
    const container=document.getElementById('tw-prev-items');
    if(!items.length){container.innerHTML=`<div class="tw-empty"><div class="tw-empty-icon">📦</div><div class="tw-empty-title">No items yet</div><div class="tw-empty-sub">Go to My Wishlist to add items first</div></div>`;return;}
    container.innerHTML=items.map(item=>`<div class="tw-parent-item">
        <div class="tw-parent-item-img">${item.img?`<img src="${item.img}" alt="" onerror="this.parentNode.innerHTML='📦'">`:twGetEmoji(item.name)}</div>
        <div class="tw-parent-item-details"><div class="tw-parent-item-name">${item.name}</div><div class="tw-parent-item-meta">Qty needed: ${item.qty||1}${item.price>0?` · $${parseFloat(item.price).toFixed(2)} each`:''}${item.vendor&&item.source==='cm'?` · ${item.vendor}`:''}${item.note?` · ${item.note}`:''}</div></div>
        ${item.claimedBy?`<span class="tw-claimed-badge"><i class="ti ti-check"></i> Being purchased by ${item.claimedBy}</span>`:`<div style="display:flex;flex-direction:column;gap:5px;align-items:flex-end">${item.source==='cm'?`<a href="${item.url||STORE_URL}" target="_blank" class="tw-buy-btn"><i class="ti ti-shopping-cart"></i> Buy on CM</a>`:item.link?`<a href="${item.link}" target="_blank" class="tw-buy-btn tw-custom"><i class="ti ti-external-link"></i> Buy Now</a>`:`<span style="font-size:11px;color:var(--tw-muted)">${item.note||'Custom item'}</span>`}<button onclick="twClaimItem('${item.id}')" class="tw-claim-btn"><i class="ti ti-heart"></i> I'm buying this</button></div>`}
      </div>`).join('');
  }

  window.twShowView=function(v){
    const sb=document.getElementById('tw-sidebar'),mn=document.getElementById('tw-main'),pv=document.getElementById('tw-preview');
    document.querySelectorAll('.tw-hn').forEach((t,i)=>t.classList.toggle('tw-on',(v==='build'&&i===0)||(v==='preview'&&i===1)));
    if(v==='build'){if(sb)sb.style.display='';if(mn)mn.style.display='';if(pv)pv.style.display='none';}
    else{if(sb)sb.style.display='none';if(mn)mn.style.display='none';if(pv)pv.style.display='block';twRenderPreview();}
  };

  window.twSwitchTab=function(t){
    ['search','custom','list','mylists'].forEach((tab,i)=>{document.querySelectorAll('.tw-tab')[i]?.classList.toggle('tw-on',tab===t);const el=document.getElementById(`tw-tab-${tab}`);if(el)el.style.display=tab===t?'block':'none';});
    if(t==='list')twRenderList(); if(t==='mylists')twRenderListManager();
  };

  window.twOpenShare=async function(){
    if(!twCurrentList||!twItems().length){twToast('Add items to your wishlist first!');return;}
    const modal=document.getElementById('tw-share-modal'), linkEl=document.getElementById('tw-share-link');
    if(modal)modal.classList.add('tw-on');
    if(linkEl)linkEl.textContent='Generating short link…';
    ['tw-share-email','tw-share-fb','tw-share-sms','tw-share-twitter'].forEach(id=>{const el=document.getElementById(id);if(el)el.style.opacity='0.4';});
    let shareUrl;
    try{
      shareUrl=await twCreateShareLink();
    }catch(e){
      console.warn('TW: URL shortener failed, using long URL:',e.message);
      const t=twCurrentList?.teacher||{};
      const data={v:1,n:t.name||'',g:t.grade||'',m:t.msg||'',av:twAvatarImg||'',items:twItems().filter(i=>!i.purchased).map(i=>({id:i.id,name:i.name,price:i.price,img:i.img||'',url:i.url||'',vendor:i.vendor||'',sku:i.sku||'',qty:i.qty||1,note:i.note||'',link:i.link||'',source:i.source||'cm'}))};
      shareUrl=`${PAGE_URL}?tw=${btoa(unescape(encodeURIComponent(JSON.stringify(data))))}`;
    }
    if(linkEl)linkEl.textContent=shareUrl;
    const name=twCurrentList.teacher.name||'Your Teacher';
    const shortMsg=`Check out ${name}'s classroom wishlist on CM School Supply!`;
    const fullMsg=encodeURIComponent(`${shortMsg} ${shareUrl}`);
    ['tw-share-email','tw-share-fb','tw-share-sms','tw-share-twitter'].forEach(id=>{const el=document.getElementById(id);if(el)el.style.opacity='';});
    document.getElementById('tw-share-email').onclick=()=>twOpenEmailModal(shareUrl);
    document.getElementById('tw-share-fb').onclick=()=>window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}&quote=${encodeURIComponent(shortMsg)}`);
    document.getElementById('tw-share-sms').onclick=()=>window.open(`sms:?body=${fullMsg}`);
    document.getElementById('tw-share-twitter').onclick=()=>window.open(`https://twitter.com/intent/tweet?text=${encodeURIComponent(shortMsg)}&url=${encodeURIComponent(shareUrl)}`);
  };

  window.twCloseShare=function(){document.getElementById('tw-share-modal').classList.remove('tw-on');};
  window.twCopyLink=function(){
    const link=document.getElementById('tw-share-link').textContent;
    if(link==='Generating short link…'){twToast('Please wait — generating link…');return;}
    navigator.clipboard.writeText(link).then(()=>twToast('Link copied! 🔗')).catch(()=>twToast('Select the link and copy manually'));
    twCloseShare();
  };

  function twOpenEmailModal(shareUrl){
    twCloseShare();
    const modal=document.getElementById('tw-email-modal');
    if(modal){document.getElementById('tw-email-share-url').value=shareUrl;document.getElementById('tw-email-to').value='';document.getElementById('tw-email-error').style.display='none';modal.classList.add('tw-on');}
  }
  window.twCloseEmailModal=function(){const modal=document.getElementById('tw-email-modal');if(modal)modal.classList.remove('tw-on');};
  window.twSendShareEmail=async function(){
    const toEl=document.getElementById('tw-email-to'),errEl=document.getElementById('tw-email-error'),btnEl=document.getElementById('tw-email-send-btn'),to=toEl.value.trim();
    if(!to||!to.includes('@')){errEl.textContent='Please enter a valid email address';errEl.style.display='block';return;}
    errEl.style.display='none';btnEl.textContent='Sending…';btnEl.disabled=true;
    const shareUrl=document.getElementById('tw-email-share-url').value,t=twCurrentList?.teacher||{};
    try{
      const res=await fetch(NETLIFY_URL+'/.netlify/functions/send-share-email',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({to,teacherName:t.name||'Your Teacher',grade:t.grade||'',message:t.msg||'',shareUrl,listName:twCurrentList?.name||'',items:twItems().filter(i=>!i.purchased).map(i=>({name:i.name,price:i.price,qty:i.qty,vendor:i.vendor,img:i.img,url:i.url,source:i.source,link:i.link}))})});
      const data=await res.json();
      if(data.success){twCloseEmailModal();twToast('Wishlist emailed successfully! 📧');}
      else{errEl.textContent='Could not send email. Please try again.';errEl.style.display='block';}
    }catch(e){errEl.textContent='Could not send email. Please check your connection.';errEl.style.display='block';}
    finally{btnEl.textContent='Send Email';btnEl.disabled=false;}
  };

  window.twClaimItem=function(itemId){const modal=document.getElementById('tw-claim-modal');if(modal){document.getElementById('tw-claim-item-id').value=itemId;document.getElementById('tw-claim-parent-name').value='';document.getElementById('tw-claim-parent-email').value='';document.getElementById('tw-claim-error').style.display='none';modal.classList.add('tw-on');}};
  window.twCloseClaimModal=function(){const modal=document.getElementById('tw-claim-modal');if(modal)modal.classList.remove('tw-on');};
  window.twSubmitClaim=async function(){
    const itemId=document.getElementById('tw-claim-item-id').value,parentName=document.getElementById('tw-claim-parent-name').value.trim(),parentEmail=document.getElementById('tw-claim-parent-email').value.trim();
    const errEl=document.getElementById('tw-claim-error'),btnEl=document.getElementById('tw-claim-submit-btn');
    if(!parentName){errEl.textContent='Please enter your name';errEl.style.display='block';return;}
    errEl.style.display='none';btnEl.textContent='Sending…';btnEl.disabled=true;
    const item=twItems().find(i=>i.id===itemId);
    if(!item){twCloseClaimModal();return;}
    const t=twCurrentList?.teacher||{};
    try{
      const res=await fetch(NETLIFY_URL+'/.netlify/functions/claim-item',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({itemId,itemName:item.name,itemImg:item.img||'',itemUrl:item.url||'',itemPrice:item.price||0,parentName,parentEmail:parentEmail||null,teacherName:t.name||'Your Teacher',teacherEmail:t.email||window.twCustomerEmail||'',listName:twCurrentList?.name||'Classroom Wishlist',shareUrl:window.location.href,customerId:twCustomerId||null,metafieldId:twMetafieldId||null,allLists:twAllLists||[]})});
      const data=await res.json();twCloseClaimModal();
      if(data.success){twToast(`Thank you, ${parentName}! The teacher has been notified 🎉`);const items=twItems();const idx=items.findIndex(i=>i.id===itemId);if(idx>-1){items[idx].claimedBy=parentName;twSetItems(items);twRenderPreview();}}
      else{twToast('Claim sent! Thank you for supporting the classroom 🙏');}
    }catch(e){twCloseClaimModal();twToast('Thank you! The teacher will be notified 🙏');}
    finally{btnEl.textContent='Confirm Purchase';btnEl.disabled=false;}
  };

  window.twPrintWishlist=function(){
    twCloseShare(); if(!twCurrentList){twToast('No wishlist selected');return;}
    const t=twCurrentList.teacher,name=t.name||'Your Teacher',items=twItems();
    const total=items.filter(i=>!i.purchased).reduce((s,i)=>s+(parseFloat(i.price||0)*(i.qty||1)),0);
    const avatarHtml=twAvatarImg?`<img src="${twAvatarImg}" class="p-avatar" alt="${name}">`:`<div class="p-avatar-ph">🍎</div>`;
    const itemsHtml=items.map(item=>`<div class="p-item${item.purchased?' p-purchased':''}">${item.img?`<img src="${item.img}" class="p-img" alt="" onerror="this.style.display='none'">`:`<div class="p-emoji">${twGetEmoji(item.name)}</div>`}<div style="flex:1;min-width:0"><div class="p-name${item.purchased?' p-purchased-text':''}">${item.name}${item.purchased?' ✓':''}</div><div class="p-meta"><span class="p-src ${item.source==='cm'?'p-src-cm':'p-src-cu'}">${item.source==='cm'?'CM School Supply':'Custom Item'}</span>${item.vendor&&item.source==='cm'?' · '+item.vendor:''}${item.sku?' · SKU: '+item.sku.toUpperCase():''}${item.note?' · '+item.note:''}</div></div><div class="p-right">${item.price>0?`<div class="p-price${item.purchased?' p-purchased-text':''}">$${parseFloat(item.price).toFixed(2)}</div>`:''}<div class="p-qty">Qty: ${item.qty||1}</div></div></div>`).join('');
    const html=`<!DOCTYPE html><html><head><meta charset="UTF-8"><title>${name}'s Wishlist</title><style>*{box-sizing:border-box;margin:0;padding:0;}body{font-family:Arial,sans-serif;color:#111;background:white;padding:32px;max-width:750px;margin:0 auto;}.no-print{margin-bottom:20px;}.btn{background:#0c2140;color:white;border:none;padding:10px 24px;border-radius:8px;font-size:14px;font-weight:bold;cursor:pointer;margin-right:8px;}.btn-red{background:#ae202f;}.p-header{display:flex;align-items:center;gap:18px;padding-bottom:18px;border-bottom:3px solid #0c2140;margin-bottom:20px;}.p-avatar{width:72px;height:72px;border-radius:50%;border:3px solid #ae202f;object-fit:cover;flex-shrink:0;}.p-avatar-ph{width:72px;height:72px;border-radius:50%;border:3px solid #ae202f;background:#e8edf4;display:flex;align-items:center;justify-content:center;font-size:30px;flex-shrink:0;}.p-teacher-name{font-size:22px;font-weight:bold;color:#0c2140;margin-bottom:3px;}.p-grade{font-size:13px;color:#5a6e85;}.p-msg{font-size:12px;color:#555;font-style:italic;background:#f4f6f9;border-left:3px solid #ae202f;padding:8px 10px;border-radius:4px;margin-top:6px;}.p-logo{margin-left:auto;text-align:right;flex-shrink:0;}.p-logo-name{font-size:18px;font-weight:bold;color:#0c2140;}.p-logo-sub{font-size:10px;color:#5a6e85;}.p-title{font-size:15px;font-weight:bold;color:#0c2140;margin-bottom:12px;}.p-item{display:flex;align-items:center;gap:12px;padding:10px 0;border-bottom:1px solid #eee;}.p-purchased{opacity:0.5;}.p-purchased-text{text-decoration:line-through;}.p-img{width:52px;height:52px;object-fit:contain;border-radius:6px;border:1px solid #eee;flex-shrink:0;}.p-emoji{width:52px;height:52px;display:flex;align-items:center;justify-content:center;font-size:26px;flex-shrink:0;background:#f4f6f9;border-radius:6px;}.p-name{font-size:13px;font-weight:bold;margin-bottom:3px;}.p-meta{font-size:11px;color:#666;}.p-src{font-size:9px;padding:1px 5px;border-radius:10px;font-weight:bold;}.p-src-cm{background:#e8edf4;color:#0c2140;}.p-src-cu{background:#fff3e0;color:#b06000;}.p-right{text-align:right;flex-shrink:0;min-width:70px;}.p-price{font-size:14px;font-weight:bold;color:#8a1824;}.p-qty{font-size:11px;color:#777;margin-top:2px;}.p-total{text-align:right;padding:12px 0 8px;font-size:14px;font-weight:bold;color:#0c2140;border-top:2px solid #0c2140;margin-top:4px;}.p-footer{margin-top:24px;text-align:center;font-size:10px;color:#aaa;border-top:1px solid #eee;padding-top:12px;}@media print{.no-print{display:none!important;}body{padding:16px;}}</style></head><body><div class="no-print"><button class="btn" onclick="window.print()">🖨️ Print Now</button><button class="btn btn-red" onclick="window.close()">✕ Close</button></div><div class="p-header">${avatarHtml}<div style="flex:1"><div class="p-teacher-name">${name}</div>${t.grade?`<div class="p-grade">${t.grade}</div>`:''} ${t.msg?`<div class="p-msg">"${t.msg}"</div>`:''}</div><div class="p-logo"><div class="p-logo-name">CM School Supply</div><div class="p-logo-sub">shopcmss.com</div><div class="p-logo-sub">Family-owned since 1972</div></div></div><div class="p-title">❤️ ${twCurrentList.name} <span style="font-size:12px;font-weight:normal;color:#5a6e85">${items.length} item${items.length!==1?'s':''}</span></div>${itemsHtml}${total>0?`<div class="p-total">Remaining Total: $${total.toFixed(2)}</div>`:''}<div class="p-footer">Shop at shopcmss.com · CM School Supply, Inc. · Family-owned since 1972<br>Printed ${new Date().toLocaleDateString('en-US',{year:'numeric',month:'long',day:'numeric'})}</div></body></html>`;
    const win=window.open('','_blank','width=800,height=700,scrollbars=yes');
    if(!win){twToast('Please allow popups to print');return;}
    win.document.open();win.document.write(html);win.document.close();
  };

  function twInitCustomerSession(){
    const appEl=document.getElementById('teacherwish-app'),loginBanner=document.getElementById('tw-login-banner'),accountBar=document.getElementById('tw-account-bar');
    if(!appEl)return;
    const customerId=appEl.dataset.customerId,customerName=(appEl.dataset.customerName||'').trim();
    const loginUrl=appEl.dataset.loginUrl||'/account/login',accountUrl=appEl.dataset.accountUrl||'/account';
    const loginBtn=document.getElementById('tw-login-btn'),acctLink=document.getElementById('tw-account-link');
    const currentPath=window.location.pathname+window.location.search;
    if(loginBtn)loginBtn.href=loginUrl||'/account/login?return_url='+encodeURIComponent(currentPath);
    if(acctLink)acctLink.href=accountUrl||'/account';
    if(customerId&&customerId!==''&&customerId!=='nil'&&customerId!=='0'){
      twCustomerId=customerId;twCloudEnabled=true;
      if(accountBar){accountBar.style.display='block';const nameEl=document.getElementById('tw-account-name');if(nameEl)nameEl.textContent=customerName||'Welcome back!';const sub=accountBar.querySelector('.tw-account-bar-sub');if(sub)sub.textContent='— syncing your wishlists across all devices';}
      const customerEmail=appEl.dataset.customerEmail||'';
      if(customerEmail){window.twCustomerEmail=customerEmail;if(twCurrentList&&!twCurrentList.teacher.email){twCurrentList.teacher.email=customerEmail;twSaveAll();}}
      const nameField=document.getElementById('tw-teacher-name');
      if(nameField&&!nameField.value&&customerName&&twCurrentList&&!twCurrentList.teacher.name){nameField.value=customerName;twCurrentList.teacher.name=customerName;twSaveAll();}
      if(twCloudEnabled){twLoadFromCloud(customerId).then(loaded=>{if(loaded){if(twCurrentList)twActivateList(twCurrentList);else if(twAllLists.length>0)twActivateList(twAllLists[0]);twRenderListManager();twRenderList();twUpdateStats();}});}
    }else{
      const dismissed=sessionStorage.getItem('tw_login_dismissed');
      if(!dismissed&&loginBanner)loginBanner.style.display='block';
    }
  }

  window.twDismissLoginBanner=function(){const b=document.getElementById('tw-login-banner');if(b)b.style.display='none';sessionStorage.setItem('tw_login_dismissed','1');};

  document.addEventListener('DOMContentLoaded',()=>{
    const avIn=document.getElementById('tw-av-input');
    if(avIn)avIn.addEventListener('change',function(e){const f=e.target.files[0];if(!f)return;const r=new FileReader();r.onload=ev=>{twAvatarImg=ev.target.result;document.getElementById('tw-av-display').innerHTML=`<img src="${twAvatarImg}" alt="Teacher">`;twQueueSave();twToast('Photo uploaded! 📸');};r.readAsDataURL(f);});
    ['tw-teacher-name','tw-teacher-grade','tw-teacher-msg'].forEach(id=>{const el=document.getElementById(id);if(el)el.addEventListener('input',twQueueSave);});
    const sq=document.getElementById('tw-search-q');if(sq)sq.addEventListener('keydown',e=>{if(e.key==='Enter')twSearch();});
    const cn=document.getElementById('tw-c-name');if(cn)cn.addEventListener('keydown',e=>{if(e.key==='Enter')twAddCustom();});
    const mo=document.getElementById('tw-share-modal');if(mo)mo.addEventListener('click',e=>{if(e.target===mo)twCloseShare();});
    twRenderCategoryBtns();
  });

  function twShowStatus(msg){const el=document.getElementById('tw-status'),tx=document.getElementById('tw-status-text');if(el)el.classList.add('tw-on');if(tx)tx.textContent=msg;}
  function twHideStatus(){const el=document.getElementById('tw-status');if(el)el.classList.remove('tw-on');}
  function twToast(msg){const t=document.getElementById('tw-toast');if(!t)return;t.innerHTML=`<i class="ti ti-check"></i> ${msg}`;t.classList.add('tw-on');clearTimeout(twToastTimer);twToastTimer=setTimeout(()=>t.classList.remove('tw-on'),2800);}

  document.addEventListener('DOMContentLoaded',async()=>{
    const params=new URLSearchParams(window.location.search);
    if(params.get('tw')){if(twCheckLegacyShareLink())return;}
    twLoadFromStorage();
    if(twAllLists.length===0)twNewList('Back to School '+new Date().getFullYear());
    else if(twCurrentList)twActivateList(twCurrentList);
    twInitCustomerSession();
    twRenderListManager();
    twRenderList();
    twUpdateStats();
    twLoadCatalog();
  });

})();
